import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { MemberSearchBadge } from './member-search-badge';
import withTranslate from '../../hoc/with-translate';
import styles from './member-search.scss';
import { SearchIcon } from '../icons/search-icon';
import Show from '../../hoc/show';

const classNames = require('classnames');

const SEARCH_DELAY = 400;

class MembersSearch extends React.Component {
  constructor() {
    super();
    this.handleChange = _.debounce((value) => this.props.onChange(value), SEARCH_DELAY);
  }

  state = {
    focus: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.focusSearch) {
      this.searchInput.focus();
      this.setState({ focus: true });
    }
  }

  setSearchInput(ref) {
    this.searchInput = ref;
  }

  render() {
    const { className, count, displayCount, value, t, badge } = this.props;
    return (
      <div
        className={classNames(styles.container, className, {
          [styles.focus]: this.state && this.state.focus,
        })}
        data-hook="am-search-field"
      >
        <span className={styles.searchIcon}>
          <SearchIcon className="ma-members-list-icon-color" />
        </span>
        <Show when={badge}>
          <MemberSearchBadge badge={badge} handleClose={this.props.onBadgeRemove} />
        </Show>
        <input
          onFocus={() => this.setState({ focus: true })}
          onBlur={() => this.setState({ focus: false })}
          className={styles.input}
          type="text"
          defaultValue={value}
          placeholder={t('member-filter.placeholder')}
          onChange={(e) => this.handleChange(e.target.value)}
          ref={(ref) => this.setSearchInput(ref)}
        />
        {displayCount && this.renderCount(count)}
        <div className={classNames(styles.line, 'ma-all-members-search-bg')} />
      </div>
    );
  }

  renderCount(count) {
    return <span className={styles.count}>{count}</span>;
  }
}

MembersSearch.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  count: PropTypes.number,
  displayCount: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func,
  focusSearch: PropTypes.bool,
  badge: PropTypes.object,
  onBadgeRemove: PropTypes.func.isRequired,
};

export default _.flowRight(withTranslate)(MembersSearch);
